import { render, staticRenderFns } from "./TextAddress.vue?vue&type=template&id=4ef5a8fa&scoped=true&"
import script from "./TextAddress.vue?vue&type=script&lang=js&"
export * from "./TextAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef5a8fa",
  null
  
)

export default component.exports